const figures = {
    "F1": {
        "image": "./figures/Fig1.jpg",
        "caption": "Sample Urban Representation and Corresponding Wind Factors: Representative samples of urban block geometries from a number of cities including San Francisco, Singapore and Cambridge, were selected for the study. For each urban patch, 8 CFD simulations are performed representing wind coming from the eight cardinal directions. For each simulation, 10 horizontal slices of wind factor results are extracted starting at 1.5m above ground at 1.5m intervals. The figure shows one sample of an urban configuration bounded to 512x512 square meters and its corresponding wind factor results.",
        "width": "80%",
        "maxWidth": "800px"
    },
    "F2": {
        "image": "./figures/Fig2.jpg",
        "caption": "Urban Representation Encoding: Four input channels are used to represent the urban context representing respectively global height features, subtractive local features (such as tunnels, carved balconies, arcades, etc.), topography and additive local features (such as trees, shading devices, etc.).",
        "width": "80%",
        "maxWidth": "800px"
    },
    "F3": {
        "image": "./figures/Fig3.jpg",
        "caption": "Sample Global Height and Wind Factor Paired Maps: One output channel is defined to each input set and represents wind factor magnitudes. The figure shows a sample of such outputs and their corresponding global height features map and 3D model.",
        "width": "80%",
        "maxWidth": "800px"
    },
    "F4": {
        "image": "./figures/Fig4.jpg",
        "caption": "cGAN Predictions as Epochs Increase: Prediction samples are shown at early and late epochs of the training process along with their corresponding ground truth wind factor results, global height map and 3D model. The predictions change from random noise in the early epochs to representations of wind flow identifying zones of influence towards the end of training.",
        "width": "80%",
        "maxWidth": "800px"
    },
    "F5": {
        "image": "./figures/Fig5.jpg",
        "caption": "Testing Set Sample Generator Predictions, Uncertainties, and Absolute Errors: A sample of model predictions for select urban patches is shown as well as their associated uncertainties and the absolute error. Visual inspection of results shows the model's capacity to identify zones of impact created by wind obstructions in an urban scene. It also shows its limited capacity to capture the scale of impact for high wind factor zones. Other artifacts include inconsistent color patches in portions of the image, and grainy noise.",
        "width": "80%",
        "maxWidth": "800px"
    },
};

export default figures;